var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.activity.units === "Hours" &&
    !(
      _vm.timeEntry.activityCode === _vm.$acConstants("OUT_TRAVEL_TIME_CODE") &&
      _vm.timeEntry.isNewTransportation
    )
      ? _c("div", { class: { "has-error": _vm.errors.has("quantity") } }, [
          _c(
            "label",
            {
              staticClass: "col-sm-2 control-label",
              attrs: { for: "quantity" }
            },
            [_vm._v("Time:")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 margin-bottom-xs" }, [
            _c("div", [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.hours,
                      expression: "timeEntry.hours"
                    }
                  ],
                  key: "quantity-hours",
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    step: "0.1",
                    id: "quantity",
                    name: "quantity",
                    placeholder: "How long?",
                    min: "0",
                    max: _vm.codeTimeLimitMax,
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: { value: _vm.timeEntry.hours },
                  on: {
                    change: function($event) {
                      return _vm.round($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "hours", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-addon" }, [
                  _vm._v("hrs")
                ])
              ]),
              _vm._v(" "),
              _vm.codeTimeLimitMessage != ""
                ? _c("div", { staticClass: "text-warning" }, [
                    _vm._v(_vm._s(_vm.codeTimeLimitMessage))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("quantity")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("quantity")))
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm.activity.units === "Dollars"
      ? _c("div", { class: { "has-error": _vm.errors.has("quantity") } }, [
          _c(
            "label",
            {
              staticClass: "col-sm-2 control-label",
              attrs: { for: "quantity" }
            },
            [_vm._v("Quantity:")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 margin-bottom-xs" }, [
            _c("div", [
              _c("div", { staticClass: "input-group" }, [
                _c("span", { staticClass: "input-group-addon" }, [_vm._v("$")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.dollars,
                      expression: "timeEntry.dollars"
                    }
                  ],
                  key: "quantity-dollars",
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    step: "0.01",
                    id: "quantity",
                    name: "quantity",
                    placeholder: "How much?",
                    min: "0",
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: { value: _vm.timeEntry.dollars },
                  on: {
                    change: function($event) {
                      return _vm.round($event, 2)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "dollars", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.errors.has("quantity")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("quantity")))
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm.activity.units === "Units" &&
        !(
          _vm.timeEntry.activityCode ===
            _vm.$acConstants("OUT_KILOMETRES_CODE") &&
          _vm.timeEntry.isNewTransportation
        )
      ? _c("div", { class: { "has-error": _vm.errors.has("quantity") } }, [
          _c(
            "label",
            {
              staticClass: "col-sm-2 control-label",
              attrs: { for: "quantity" }
            },
            [_vm._v("Quantity:")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 margin-bottom-xs" }, [
            _c("div", [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.units,
                      expression: "timeEntry.units"
                    }
                  ],
                  key: "quantity-units",
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    step: "1",
                    id: "quantity",
                    name: "quantity",
                    placeholder: "How many?",
                    min: "0",
                    max: _vm.codeTimeLimitMax,
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: { value: _vm.timeEntry.units },
                  on: {
                    change: function($event) {
                      return _vm.round($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "units", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.codeTimeLimitMessage != ""
                ? _c("div", { staticClass: "text-warning" }, [
                    _vm._v(_vm._s(_vm.codeTimeLimitMessage))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("quantity")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("quantity")))
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.timeEntry.activityCode === _vm.$acConstants("OUT_KILOMETRES_CODE") ||
      _vm.timeEntry.activityCode ===
        _vm.$acConstants("OUT_TRAVEL_TIME_CODE")) &&
    _vm.timeEntry.isNewTransportation
      ? _c("div", [
          _c(
            "label",
            {
              staticClass: "col-sm-2 control-label",
              attrs: { for: "quantity" }
            },
            [_vm._v("Time:")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-sm-2 margin-bottom-xs",
              class: { "has-error": _vm.errors.has("quantity") }
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.hours,
                      expression: "timeEntry.hours"
                    }
                  ],
                  key: "quantity-hours",
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    step: "0.1",
                    id: "quantity",
                    name: "quantity",
                    placeholder: "How long?",
                    min: "0",
                    max: _vm.codeTimeLimitMax,
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: { value: _vm.timeEntry.hours },
                  on: {
                    change: function($event) {
                      return _vm.round($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "hours", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-addon" }, [
                  _vm._v("hrs")
                ])
              ]),
              _vm._v(" "),
              _vm.codeTimeLimitMessage != "" && _vm.errors.has("quantity")
                ? _c("div", { staticClass: "text-warning" }, [
                    _vm._v(_vm._s(_vm.codeTimeLimitMessage))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("quantity")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("quantity")))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "col-sm-2 col-md-1 control-label",
              attrs: { for: "distance" }
            },
            [_vm._v("Distance:")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-sm-2 margin-bottom-xs",
              class: { "has-error": _vm.errors.has("distance") }
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.units,
                      expression: "timeEntry.units"
                    }
                  ],
                  key: "quantity-units",
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    step: "1",
                    id: "distance",
                    name: "distance",
                    placeholder: "How many?",
                    min: "0",
                    max: _vm.codeTimeLimitMax,
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: { value: _vm.timeEntry.units },
                  on: {
                    change: function($event) {
                      return _vm.round($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "units", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-addon" }, [_vm._v("KM")])
              ]),
              _vm._v(" "),
              _vm.codeTimeLimitMessage != "" && _vm.errors.has("distance")
                ? _c("div", { staticClass: "text-warning" }, [
                    _vm._v(_vm._s(_vm.codeTimeLimitMessage))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("distance")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("distance")))
                  ])
                : _vm._e()
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62b1a9b0", { render: render, staticRenderFns: staticRenderFns })
  }
}